import React, { FC }        from 'react';
import styled               from 'styled-components';
import {
  Dialog as MuiDialog,
  DialogTitle as MuiDialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText,
}                           from '@material-ui/core';
import { Close }            from '@material-ui/icons';
import { INote }            from '@typings/accountManagement';
import { getFormattedDate } from '@utils/commonFunctions';

interface IFullNoteModal {
  isOpen      : boolean;
  noteToView  : INote | null;
  handleClose : (note: INote | null) => void;
}

const Dialog = styled(MuiDialog)`
  [class*='MuiPaper'] {
    border-radius : 20px;
    padding       : 0;

    @media (min-width: 600px) {
      min-width: 600px;
    }

    @media (max-width: 600px) {
      border-top-left-radius: 0;
    }
  }
`;

const DialogTitle = styled(MuiDialogTitle)`
  background-color: #E0F3FF;

  p, span, svg {
    color: ${({ theme: { textColor } }): string => textColor.black};
  }
`;

const FullSizeHeader = styled.div`
  display         : flex;
  align-items     : center;
  justify-content : space-between;
  width           : 100%;
  height          : 50px;
  padding         : 30px 25px 15px;

  span p {
    font-weight : 300;
    font-size   : 16px;
  }

  svg {
    position : relative;
    cursor   : pointer;
    top      : -17px;
    right    : -21px;
  }
`;

export const FullNoteModal: FC<IFullNoteModal> = ({
  isOpen,
  noteToView,
  handleClose,
}) => (
  <div>
    <Dialog
      open             = {isOpen}
      onClose          = {(): void => handleClose(null)}
      scroll           = "body"
      aria-labelledby  = "scroll-dialog-title"
      aria-describedby = "scroll-dialog-description"
    >
      <DialogTitle id="scroll-dialog-title">
        <FullSizeHeader id="scroll-dialog-title">
          <span>{getFormattedDate(noteToView?.noteTime, 'MM/DD/YYYY')}</span>
          <span>{getFormattedDate(noteToView?.noteTime, 'HH:mm A z')}</span>
          <span>{noteToView?.authorFullName ?? 'User Name'}</span>
          <Close onClick={(): void => handleClose(null)} />
        </FullSizeHeader>
      </DialogTitle>

      <DialogContent>
        <DialogContentText id="scroll-dialog-description">
          {noteToView && noteToView?.text}
        </DialogContentText>
      </DialogContent>
      <DialogActions />
    </Dialog>
  </div>
);
